import ApplicationController from '../application_controller'

// TODO: Build out options from Activity models
// TODO: Restrict options already selected

export default class extends ApplicationController {

	static outlets = [
		'input-to-link',
		'dynamic-table-header',
		'app--session-participant-activity-form-row',
	]

	static targets = [
		'sessionActivity',
		'sessionActivityContainer',
		'deleteButton',
	]

	connect() {
		this.updateCurrentIndex()
		this.updateRemoveButtons()
	}

	sessionActivityTargetConnected(_element) {
		this.updateCurrentIndex()
		this.updateRemoveButtons()
		this.inputToLinkOutlets.forEach(itl => itl.inputChanged())
	}

	// This should reflect the current number of rows that have been created *historically*.
	//
	// The reason being, you could add several rows, delete one, and add one again,
	// then get duplicate index numbers used within session[session_activity][index].
	updateCurrentIndex() {
		this.currentIndex = this.sessionActivityTargets.length
	}

	// This will restrict removing the last singular SessionActivity because there must be at least one per Session model.
	updateRemoveButtons() {
		if (this.sessionActivityTargets.filter(sat => !sat.classList.contains('d-none')).length > 1) { // show all remove buttons
			for (const button of this.deleteButtonTargets) {
				button.classList.remove('invisible')
			}
		}
		else { // hide the last delete button
			for (const button of this.deleteButtonTargets) {
				button.classList.add('invisible')
			}
		}
	}

	addActivityRow() {
		const existingActivityElement = this.sessionActivityTarget

		const containerElement = document.createElement('div')
		containerElement.innerHTML = existingActivityElement.outerHTML

		let selectActivityElement = document.createElement('select')
		selectActivityElement.classList.add('form-select')
		selectActivityElement.classList.add('select-activity')
		selectActivityElement.id = `session_session_activity_${this.currentIndex}`
		selectActivityElement.name = `session_activities[${this.currentIndex}][activity_id]`
		// still need to finish building...

		const selectActivityColElement = containerElement.querySelector('div[data-controller=choices]')
		selectActivityColElement.innerHTML = ''
		selectActivityColElement.append(selectActivityElement)

		const activityDurationElement = containerElement.querySelector('select.select-activity')
		activityDurationElement.name = "session[session_activity][${this.currentIndex}][duration]"

		this.sessionActivityContainerTarget.append(containerElement.firstChild)
		this.currentIndex += 1
		this.updateRemoveButtons()
	}

	deleteActivityRow(event) {
		const sai = event.currentTarget.closest('.session-activity-item')

		if (sai.querySelector('input[name="session[session_activities_attributes][][id]"]').value == '') {
			sai.remove()
		} else {
			sai.classList.add('d-none')
			sai.querySelector('input[name="session[session_activities_attributes][][_destroy]"]').value = '1'
		}

		this.updateRemoveButtons()
		this.updateOutlets()
	}

	activityChanged(_event) {
		this.updateOutlets()
	}

	durationChanged(_event) {
		this.updateOutlets()
	}

	updateOutlets() {
		const saModels = this.sessionActivityModels()

		this.appSessionParticipantActivityFormRowOutlets.forEach(outlet => {
			outlet.updateSessionActivities(saModels)
		})

		const columns = saModels.map(saModel => {
			return { name: saModel['activity_name'] }
		})

		this.dynamicTableHeaderOutlets.forEach(outlet => {
			outlet.setColumns(columns)
		})
	}

	sessionActivityModels() {
		return this.sessionActivityTargets.map(sa => {
			const activitySelect = sa.querySelector('select[name$="[activity_id]"]')
			const selectedActivityOption = activitySelect.selectedOptions[0] || {}

			const durationInput = sa.querySelector('input[name$="[duration]"]')
			return {
				activity_name: selectedActivityOption.innerText,
				activity_id: selectedActivityOption.value,
				duration: durationInput.value,
			}
		})
	}

}
